import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { linkedProviders, providerNames } from './socialProviders';

// 회원가입 실패 응답이 동일 프로필 중복(DUPLICATE_PROFILE)이면 안내에 필요한 정보만 추린다.
export function toDuplicateProfile(data) {
    if (data?.code !== 'DUPLICATE_PROFILE') return null;
    return { email: data.email || '', providers: linkedProviders(data.socialAccounts), message: data.error || data.message || '' };
}

// 동일 프로필 계정이 이미 있을 때 기존 계정 정보와 로그인 방법을 안내한다.
export default function DuplicateProfileNotice({ profile, onNaverLogin }) {
    return <section className="auth-recovery-result auth-duplicate" role="alert">
        <h2>이미 가입된 계정이 있습니다</h2>
        <p>{profile.message || '동일한 이름·생년월일·성별의 계정이 이미 있습니다.'}</p>
        {profile.email && <p>가입한 이메일: <strong>{profile.email}</strong></p>}
        {profile.providers.length > 0 && <p className="auth-recovery-social">{providerNames(profile.providers)} 계정이 연동되어 있습니다.</p>}
        <div className="auth-recovery-actions">
            <Link to="/login">로그인하기</Link>
            {profile.providers.includes('naver') && <button type="button" onClick={onNaverLogin}>네이버로 로그인</button>}
            <Link to="/find-password">비밀번호 찾기</Link>
        </div>
    </section>;
}

DuplicateProfileNotice.propTypes = {
    profile: PropTypes.shape({ email: PropTypes.string, providers: PropTypes.arrayOf(PropTypes.string).isRequired, message: PropTypes.string }).isRequired,
    onNaverLogin: PropTypes.func.isRequired,
};
